import { Component, OnInit } from "@angular/core";
import { BaseService } from "../base.service";
import { GridComponent } from "../grid/grid.component";
import * as config from "../../../assets/grid_config.json";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-grid-list",
  templateUrl: "./grid-list.component.html",
  styleUrls: ["./grid-list.component.css"],
  providers: [GridComponent],
})
export class GridListComponent implements OnInit {
  isContent = true;
  isLoding = true;
  imageType = "portrait";
  gridConfig: any = (config as any).default;
  popularVideos: any = []
  apiParam = {
    slug: "",
    type: "music",
    limit: 15,
    offset: 0,
    feature: true,
    banner: true,
  }; constructor(
    public service: BaseService,
    public gridComponent: GridComponent
  ) { }

  ngOnInit(): void {
    this.setData()

  }
  setData() {
    if (localStorage.getItem(environment.pagesLocalStorageKey)) {
      const localdata = JSON.parse(
        localStorage.getItem(environment.pagesLocalStorageKey)
      );

      const index = localdata
        .map((el) => {
          return el.hasOwnProperty("popular_courses");
        })
        .indexOf(true);
      if (index != -1) {
        this.popularVideos = localdata[index]['popular_courses'];
        this.service.popularSeries = true;
        this.isLoding = false;
      } else {
        this.popularCourses();
      }
    } else {
      this.popularCourses();
    }
  }
  popularCourses() {
    this.service.popularCourses(this.apiParam).subscribe(
      (data: any) => {
        let localdata
        if (data.results.length > 0) {
          this.service.popularSeries = true;
          this.popularVideos = data.results
          this.isLoding = false;
          if (localStorage.getItem(environment.localStorageLangKey)) {
            localdata = JSON.parse(
              localStorage.getItem(environment.pagesLocalStorageKey)
            );
            localdata.push({ ["popular_courses"]: this.popularVideos });
          } else {
            localdata = [{ ["popular_courses"]: this.popularVideos }];
          }
          localStorage.setItem(
            environment.pagesLocalStorageKey,
            JSON.stringify(localdata)
          );
        } else {
          this.service.popularSeries = false;
        }
      },
      (err) => {
        if (err) {
          this.isLoding = false;
          this.service.popularSeries = false;
        }

      }
    );
  }
}
